import React from 'react';
import { Grid } from '@material-ui/core';
import { FieldLabel, StyledTextField } from '../ApplicantInformationSection/styles';
export var FormField = function (_a) {
    var _b = _a.xs, xs = _b === void 0 ? 6 : _b, label = _a.label, placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange, _c = _a.type, type = _c === void 0 ? 'text' : _c, _d = _a.error, error = _d === void 0 ? false : _d, helperText = _a.helperText, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    return (React.createElement(Grid, { item: true, xs: xs },
        React.createElement(FieldLabel, null, label),
        React.createElement(StyledTextField, { variant: "outlined", placeholder: placeholder, value: value, onChange: function (e) { return onChange(e.target.value); }, type: type, error: error, helperText: helperText, disabled: disabled })));
};
export default FormField;
